"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genIcon = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../icons");
var themes_1 = require("../../../themes");
var grey40 = themes_1.colors.grey40;
var genIcon = function (_a) {
    var icon = _a.icon, _b = _a.weight, weight = _b === void 0 ? "bold" : _b, disabled = _a.disabled, S = _a.S, color = _a.color, _c = _a.className, className = _c === void 0 ? '' : _c;
    if (!icon)
        return null;
    var IconComp = icons_1.icons[icon];
    if (!IconComp)
        return null;
    return react_1.default.createElement(IconComp, { className: className, size: S ? 16 : 20, style: { color: disabled ? grey40 : (color || undefined) }, weight: weight });
};
exports.genIcon = genIcon;
